const filterByProject = (data, projectName) => data.filter(object => object.remark.toLowerCase() === projectName.toLowerCase() && object.status);
export default filterByProject;